// @flow
import deals from './common/dealsReducer';
import images from './common/imagesReducer';
import reviews from './common/reviewsReducer';
import addresses from './common/addressesReducer';
import serviceAreaMap from './common/serviceAreaMapReducer';

export default {
  beforeConfigureStore: (options: any): {|reducers: any|} => ({
    reducers: {
      ...(options || {}).reducers,
      deals,
      images,
      reviews,
      addresses,
      serviceAreaMap,
    },
  }),
};



// WEBPACK FOOTER //
// ./src/modules/store/injectors.js